import { render } from "./VaPageNotFoundSearch.vue?vue&type=template&id=deb86e4e"
import script from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js"

import "./VaPageNotFoundSearch.vue?vue&type=style&index=0&id=deb86e4e&lang=scss"
script.render = render

export default script